module.exports = __webpack_public_path__ + "static/media/glossary-icon.a5ea6b5e.svg";